import { $t } from '@/i18n';
import { computed, inject, onBeforeMount, onMounted, onUnmounted } from '@vue/composition-api';
import { INJECT_UICORE_BUS, INJECT_UICORE_RENDERER } from '@tencent/ui-core/lib/utils/consts';
import { waitForRendererMounted } from '@/utils/global/api';
import { runtimeHook } from '@/hooks/runtimeHook';
const createdEvent = {
    id: 'created',
    name: $t('k_2e31d2c1'),
    desc: $t('k_38319534'),
};
const rendererMountedEvent = {
    id: 'rendererMounted',
    name: $t('k_5e5f6e2c'),
    desc: $t('k_c4903939'),
    arguments: [
        { type: 'any', description: $t('k_fd2154bd') },
    ],
};
const allDataSourcesReadyEvent = {
    id: 'allDataSourcesReady',
    name: $t('k_3a1d25e0'),
    desc: $t('k_4736f697'),
    arguments: [
        { type: 'any', description: $t('k_fd2154bd') },
    ],
};
const destroyedEvent = {
    id: 'destroyed',
    name: $t('k_adbe1ec9'),
    desc: '',
};
// 页面片相关事件
export const EVENTS = [
    createdEvent,
    rendererMountedEvent,
    allDataSourcesReadyEvent,
    destroyedEvent,
];
// 页面片相关事件触发逻辑
export const usePageletEvent = ({ emit }) => {
    const uc = inject(INJECT_UICORE_BUS, null);
    const renderer = inject(INJECT_UICORE_RENDERER, null);
    const isDesignMode = computed(() => uc?.isDesignMode);
    onBeforeMount(() => {
        if (isDesignMode.value)
            return;
        // 初始化
        emit(createdEvent.id);
        // 数据源就绪
        const sources = renderer?.sources;
        if (sources) {
            const promises = [];
            Object.values(sources).forEach((source) => {
                promises.push(source.waitForReady());
            });
            Promise.all(promises)
                .then(() => runtimeHook.pageBeforeAllDataSourcesReady.promise(renderer))
                .then(() => {
                emit(allDataSourcesReadyEvent.id, renderer);
            });
        }
    });
    onMounted(async () => {
        if (isDesignMode.value)
            return;
        await waitForRendererMounted(renderer);
        emit(rendererMountedEvent.id, renderer);
    });
    onUnmounted(() => {
        if (isDesignMode.value)
            return;
        // 销毁
        emit(destroyedEvent.id);
    });
};
